import { render } from "./TicketsFilters.vue?vue&type=template&id=50a47dd6&scoped=true&ts=true"
import script from "./TicketsFilters.vue?vue&type=script&lang=ts"
export * from "./TicketsFilters.vue?vue&type=script&lang=ts"

import "./TicketsFilters.vue?vue&type=style&index=0&id=50a47dd6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a47dd6"]])

export default __exports__